import { render, staticRenderFns } from "./DoriSettingsSection.vue?vue&type=template&id=7a19bfb1&scoped=true&"
import script from "./DoriSettingsSection.vue?vue&type=script&lang=ts&"
export * from "./DoriSettingsSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a19bfb1",
  null
  
)

export default component.exports